import { render, staticRenderFns } from "./BatchNotEnabled.vue?vue&type=template&id=be00edb2&scoped=true&"
import script from "./BatchNotEnabled.vue?vue&type=script&lang=js&"
export * from "./BatchNotEnabled.vue?vue&type=script&lang=js&"
import style0 from "./BatchNotEnabled.vue?vue&type=style&index=0&id=be00edb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be00edb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VContainer,VIcon})
